import { render, staticRenderFns } from "./PurchaseTracker.vue?vue&type=template&id=6f39f528&"
import script from "./PurchaseTracker.vue?vue&type=script&lang=js&"
export * from "./PurchaseTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports